import { render, staticRenderFns } from "./admin-playlist.vue?vue&type=template&id=4e5aae82"
import script from "./admin-playlist.vue?vue&type=script&lang=js"
export * from "./admin-playlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports